const isBooleanCode = `import { isBoolean } from 'cristatus';

const isBoolean = isBoolean(true); //true
`;

export default isBooleanCode;
